<script>
import NavOnboarding from '@components/accountsManager/nav-onboarding.vue';
import TrainerOnboardingDesktop from '@views/accountsManager/desktop/trainer-onboarding-desktop.vue';
import TrainerOnboardingMobile from '@views/accountsManager/mobile/trainer-onboarding-mobile.vue';

import { breakpointsMixin } from '@mixins/breakpointsMixin';
import { trainerMethods, authComputed, authMethods } from '@state/helpers';

export default {
  name: 'TrainerOnboarding',
  mixins: [breakpointsMixin],
  components: {
    NavOnboarding,
    // eslint-disable-next-line vue/no-unused-components
    TrainerOnboardingDesktop,
    TrainerOnboardingMobile,
  },
  data() {
    return {
      component: '',
      loading: false,
    };
  },
  async beforeMount() {
    // All this logic moved to inside the component so we can let the user know we're preparing data
    this.loading = true;
    if (this.$route.query && this.$route.query.token) {
      // Check if we have token
      this.autoLogin(this.$route.query.token).then(async (validUser) => {
        // Validate user
        if (validUser && validUser.roles.isUser) {
          if (validUser && validUser.user && validUser.user.completedOnBoarding) {
            this.$router.push({ name: 'home' }); // Go home is user already completed onboarding
          } else {
            await this.hydrate(); // Get trainer and org to continue with onboarding flow
            this.loading = false;
          }
        } else {
          // Here we could not find a valid user
          this.$router.push({ name: '404', params: { resource: 'Valid User' } });
        }
      });
    }
  },
  mounted() {
    if (this.isDesktopView) {
      this.show();
    }
  },
  destroyed() {
    this.hide();
  },
  methods: {
    ...authMethods,
    ...trainerMethods,
    show() {
      this.$bvModal.show('trainer-onboarding-modal');
    },
    hide() {
      this.$bvModal.hide('trainer-onboarding-modal');
    },
  },
  computed: {
    ...authComputed,
  },
  watch: {
    isDesktopView(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
  },
};
</script>

<template>
  <div>
    <div v-show="isDesktopView" class="desktop">
      <NavOnboarding />
      <b-modal id="trainer-onboarding-modal" size="sm" centered no-close-on-backdrop no-close-on-esc hide-footer hide-header>
        <TrainerOnboardingDesktop v-if="!loading" />
        <BaseLoadingSpinner v-if="loading" />
      </b-modal>
    </div>
    <div class="mobile" v-show="!isDesktopView">
      <TrainerOnboardingMobile v-if="!loading" />
      <BaseLoadingSpinner v-if="loading" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.desktop {
  background: url('../../../assets/images/backgrounds/desktop/onboarding.jpg') center no-repeat;
  background-size: cover;
  display: flex;
  height: 100%;
  opacity: 0.98;
  position: absolute;
  width: 100%;
}

.mobile {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  position: relative;
  width: 100%;
  .loading {
    margin: auto;
  }
}

::v-deep .modal-dialog {
  max-width: 400px !important;
  .loading {
    margin-bottom: auto;
    margin-top: auto;
  }
  .modal-content {
    min-height: 74rem !important;
  }
}
</style>
